import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDuration'
})
export class DateDurationPipe implements PipeTransform {

  transform(oldDate): any {
      const days = (new Date().getTime() - new Date(oldDate).getTime()) / 1000 / 60 / 60 / 24;
      let months = 0;
      let years = 0;
      months = days / 30.41;
      if (months > 12) {
        years = months / 12;
        months = months % 12;
      }
      months = parseInt(months.toString(), 10);
      years = parseInt(years.toString(), 10);
      let returnString = '';
      if (years) {
        if (years > 1) {
          returnString += `${years} years `;
        } else {
          returnString += `${years} year `;
        }
      }
      if (months) {
        if (months > 1) {
          returnString += `${months} months `;
        } else {
          returnString += `${months} month `;
        }
      }
      return returnString;
  }

}
